//export const apiUrl = "http://localhost:9944"
export const apiUrl = "https://apiserver.sshvactx.com"
export const dateFormat = "MM-DD-YYYY";
export const timeFormat = "hh:mm:ss a";